import { animate, AnimationTriggerMetadata, query, stagger, style, transition, trigger } from '@angular/animations';

export const animations: AnimationTriggerMetadata[] = [
  trigger('flyIn', [
    transition('* => *', [
      query('.voucher', style({ transform: 'translateX(-10%)', opacity: 0 }), { optional: true }),
      query('.voucher',
        stagger(200, [
          animate(400, style({ transform: 'translateX(0)', opacity: 1 }))
        ]), { optional: true })
    ])
  ])
];



// WEBPACK FOOTER //
// ./src/app/vouchers/voucher-list/voucher-list.animations.ts